import {Grid} from '@mui/material';

import {CulturePillarsPageOne} from './CulturePillarsPageOne';
import {CulturePillarsPageTwo} from './CulturePillarsPageTwo';
import {FirstPage} from './FirstPage';
import {SecondPage} from './SecondPage';

export const AnalysisGuide = () => {
  return (
    <>
      <Grid
        sx={{
          breakAfter: 'page',
        }}
      >
        <FirstPage />
      </Grid>
      <Grid
        sx={{
          breakAfter: 'page',
        }}
      >
        <SecondPage />
      </Grid>
      <Grid
        sx={{
          breakAfter: 'page',
        }}
      >
        <CulturePillarsPageOne />
      </Grid>
      <Grid
        sx={{
          breakAfter: 'page',
        }}
      >
        <CulturePillarsPageTwo />
      </Grid>
    </>
  );
};
